import type { ServerFileEntry } from "@mc/types"
import { apiRequest } from "./httpClient.js"

export interface ModrinthSearchResult {
  projectId: string
  slug: string
  title: string
  description: string
  iconUrl: string | null
  downloads: number
}

export interface ModrinthVersion {
  id: string
  versionNumber: string
  name: string
  gameVersions: string[]
  loaders: string[]
  files: { url: string; filename: string; primary: boolean }[]
}

export function searchMods(query: string): Promise<{ results: ModrinthSearchResult[] }> {
  return apiRequest(`/api/v1/mods/search?query=${encodeURIComponent(query)}`)
}

export function getModVersions(projectId: string): Promise<{ versions: ModrinthVersion[] }> {
  return apiRequest(`/api/v1/mods/${projectId}/versions`)
}

export function listInstalledMods(serverId: string): Promise<{ mods: ServerFileEntry[] }> {
  return apiRequest(`/api/v1/servers/${serverId}/mods`)
}

export function installMod(serverId: string, downloadUrl: string, filename: string): Promise<{ filename: string }> {
  return apiRequest(`/api/v1/servers/${serverId}/mods`, { method: "POST", body: { downloadUrl, filename } })
}

export function deleteMod(serverId: string, filename: string): Promise<void> {
  return apiRequest(`/api/v1/servers/${serverId}/mods/${encodeURIComponent(filename)}`, { method: "DELETE" })
}
